import React from 'react';

const ArrowNarrowPrevIcon = ({isDisable}: {isDisable: boolean}) => {
    return (
        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44ZM13.3813 22.6187L21.3813 30.6187C21.723 30.9604 22.277 30.9604 22.6187 30.6187C22.9604 30.277 22.9604 29.723 22.6187 29.3813L16.1124 22.875H30C30.4832 22.875 30.875 22.4832 30.875 22C30.875 21.5168 30.4832 21.125 30 21.125H16.1124L22.6187 14.6187C22.9604 14.277 22.9604 13.723 22.6187 13.3813C22.277 13.0396 21.723 13.0396 21.3813 13.3813L13.3813 21.3813C13.0396 21.723 13.0396 22.277 13.3813 22.6187Z"
                fill={`${isDisable ? '#D7D7D7' : 'url(#paint0_linear_2002_747)'}`}
            />
            <defs>
                <linearGradient
                    id="paint0_linear_2002_747"
                    x1="-33.5"
                    y1="47.5"
                    x2="48.2321"
                    y2="62.7025"
                    gradientUnits="userSpaceOnUse">
                    <stop stopColor="#0041EA" />
                    <stop offset="0.333333" stopColor="#3BACF7" />
                    <stop offset="0.445" stopColor="#7C86D4" />
                    <stop offset="0.76" stopColor="#FF31D2" />
                    <stop offset="1" stopColor="#FF398C" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default ArrowNarrowPrevIcon;
